import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from 'react';
import { EhrIntegrationSettingsData } from '@/common/types';
import { loadEhrIntegrationSettings } from '@/common/api';

const EhrIntegrationSettingsContext =
  createContext<EhrIntegrationSettingsData | null>(null);

export const EhrIntegrationSettingsProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [settings, setSettings] = useState<EhrIntegrationSettingsData | null>(
    null
  );

  useEffect(() => {
    loadEhrIntegrationSettings()
      .then(setSettings)
      .catch((err) =>
        console.error('Failed to load EHR integration settings:', err)
      );
  }, []);

  return (
    <EhrIntegrationSettingsContext.Provider value={settings}>
      {children}
    </EhrIntegrationSettingsContext.Provider>
  );
};

export const useEhrIntegrationSettings = () =>
  useContext(EhrIntegrationSettingsContext);
